"use client";
import { useWindowScroll, useIsomorphicEffect } from "@mantine/hooks";
import { useRef, useState } from "react";
const isFixed = (current, fixedAt) => current <= fixedAt;
const isPinned = (current, previous) => current < previous;
const isReleased = (current, previous, fixedAt) => !isPinned(current, previous) && !isFixed(current, fixedAt);
const useHeadroom = ({ fixedAt = 0, onPin, onFix, onRelease } = {}) => {
  const scrollRef = useRef(0);
  const [{ y: scrollPosition }] = useWindowScroll();
  const [currentScrollY, setCurrentScrollY] = useState(0);
  const [pinned, setPinned] = useState(isPinned(scrollPosition, scrollRef.current));
  useIsomorphicEffect(() => {
    setCurrentScrollY((prevValue) => {
      setPinned(isPinned(scrollPosition, prevValue));
      if (pinned) {
        onPin == null ? void 0 : onPin();
      }
      return scrollPosition;
    });
  }, [scrollPosition, onPin]);
  useIsomorphicEffect(() => {
    if (isFixed(scrollPosition, fixedAt)) {
      onFix == null ? void 0 : onFix();
    }
  }, [scrollPosition, fixedAt, onFix]);
  useIsomorphicEffect(() => {
    if (isReleased(scrollPosition, scrollRef.current, fixedAt)) {
      onRelease == null ? void 0 : onRelease();
    }
  }, [scrollPosition, onRelease]);
  useIsomorphicEffect(() => {
    scrollRef.current = window.scrollY;
  }, [scrollPosition]);
  if (pinned) {
    return true;
  }
  if (isFixed(scrollPosition, fixedAt)) {
    return true;
  }
  return false;
};
export {
  isFixed,
  isPinned,
  isReleased,
  useHeadroom
};
